import { Person } from '@/types/person';

const personNeedsNewProgramQualification = (person: Person): boolean => {
  const { program_qualification } = person;

  return !program_qualification || !!program_qualification.ended_at;
};

export default personNeedsNewProgramQualification;
